import React, { useMemo, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Collapse } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Breadcrumb from 'components/commons/Breadcrumb';

import './FrequentQuestions.scss';

const FrequentQuestions = ({ client, frequentQuestions }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const items = useMemo(
    () => (Array.isArray(frequentQuestions) ? frequentQuestions.filter((item) => item?.pregunta && item?.rta) : []),
    [frequentQuestions],
  );

  let marginStyle = '';
  switch (client?.design) {
    case 5:
      marginStyle = 'd5';
      break;
    case 6:
      marginStyle = 'man';
      break;
    default:
      marginStyle = '';
  }

  const storeName = client?.name_show || client?.name || 'la tienda';

  return (
    <main className={`faq-page ${marginStyle}`} data-testid="faq-page">
      <div className="faq-page__container">
        <Breadcrumb urls={['/preguntas-frecuentes']} names={['Preguntas frecuentes']} />

        <section className="faq-hero">
          <span className="faq-hero__eyebrow">Ayuda de {storeName}</span>
          <h1>Preguntas frecuentes</h1>
          <p>Respuestas rápidas para comprar con confianza y resolver dudas antes de hacer tu pedido.</p>
        </section>

        {items.length === 0 ? (
          <section className="faq-empty" aria-label="Sin preguntas frecuentes">
            <div className="faq-empty__icon">
              <i className="fa fa-question-circle" aria-hidden="true" />
            </div>
            <h2>Todavía no hay preguntas cargadas</h2>
            <p>Si necesitás ayuda, podés escribirle directamente a la tienda desde la sección de contacto.</p>
            <Link to="/contacto">Ir a contacto</Link>
          </section>
        ) : (
          <section className="faq-list" aria-label="Preguntas frecuentes">
            {items.map((item, index) => {
              const isOpen = openIndex === index;
              const panelId = `faq-answer-${item.id || index}`;

              return (
                <article className={`faq-card ${isOpen ? 'is-open' : ''}`} key={item.id || item.pregunta}>
                  <button
                    type="button"
                    className="faq-card__button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                  >
                    <span>{item.pregunta}</span>
                    <ExpandMoreIcon />
                  </button>

                  <Collapse in={isOpen}>
                    <div id={panelId} className="faq-card__answer">
                      {item.rta}
                    </div>
                  </Collapse>
                </article>
              );
            })}
          </section>
        )}
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  client: state.app.client,
  frequentQuestions: state.app.frequentQuestions,
});

export default connect(mapStateToProps)(FrequentQuestions);
